import React from 'react';
import { withRouter } from 'react-router-dom';

import GiftcardInfo from "./components/GiftcardInfo/index";
import LoadingSpinner from "../../components/LoadingSpinner/index";
import LookupForm from "./components/LookupForm/index";

import GiftcardsApi from "../../services/portal-api/GiftcardsApi";
import Header from "../../components/Header/index";
import SystemErrorMessage from "../../components/SystemErrorMessage/index";
import withAuth from "../../services/withAuth";
import MembersApi from '../../services/portal-api/MembersApi';
import AuthService from '../../services/AuthService';
import NotFound from '../NotFound';

class GiftcardLookup extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            cardNumber: this.getSlugFromUrl(this.props.location),
            isLoading: false,
            response: null
        };
    }

    componentDidMount() {
        document.title = 'Gift Card / Voucher Lookup - duskPortal';
        document.body.className = 'page--purple';
        this.navListener = this.props.history.listen((location) => {
            this.setState({
                cardNumber: this.getSlugFromUrl(location)
            }, () => {
                this.initUi();
                this.doLookup();
            });
        });
        this.initUi();
        this.doLookup();
        MembersApi.getCountry((result) => {
            if (result.status === 401) {
                this.props.sessionExpired();
                return;
            }
        }); // just call to check token expiry
    }

    componentWillUnmount() {
        // No longer care about any API calls in progress
        this.callId = null;

        // Unbind the nav listener
        this.navListener();
    }

    initUi() {
        if (AuthService.can('Gift card lookup') && this.state.cardNumber === '') {
            const cardNumberInput = document.getElementById('cardNumber');
            cardNumberInput.focus()
        }
    };

    getSlugFromUrl(location) {
        let slug = location.pathname;
        slug = slug.substring(slug.lastIndexOf('/') + 1);
        if (slug === 'giftcards') {
            return slug = '';
        }
        slug = slug.replace(/-/g, ' ');
        return slug;
    }

    handleCardNumberChange = (cardNumber) => {
        this.setState({
            cardNumber: cardNumber
        });
    };

    handleSubmit = (event) => {
        // Tidy card number, only allow a-z, 0-9 and spaces
        const cardNumber = this.state.cardNumber.replace(/[^a-z0-9 ]/gi, '');
        this.handleCardNumberChange(cardNumber);
        // Update URL
        const slug = cardNumber.replace(/\s/g, '-');
        this.props.history.push('/giftcards/' + slug);
    };

    doLookup() {

        // Ensure there's a card number
        if (this.state.cardNumber === '') {
            this.setState({
                isLoading: false,
                response: null
            });
            return;
        }

        // Show loading and reset state
        this.setState({
            isLoading: true,
            response: null
        });

        // Fetch data
        this.callId = GiftcardsApi.getGiftcard(this.state.cardNumber, (result, callId) => {

            // Check if we're still interesting in this response
            if (callId !== this.callId) {
                return;
            }

            // Check for auth
            if (result.status === 401) {
                this.props.sessionExpired();
                this.setState({
                    isLoading: false,
                });
                return;
            }

            this.setState({
                isLoading: false,
                response: result,
            });
        });
    };

    render() {
        return (
            AuthService.can('Gift card lookup') ?
                <div>
                    <Header />
                    <main className="content" role="main">

                        <div className="vertab">
                            <div className="vertab--inner viewport--width">

                                <div className="container padding--100 text--center text--15">
                                    <div className="icon--wrap padding--20--top">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96.4 76.2" width="96" height="76" className="icon">
                                            <path className="path--color" d="M44.6 58.2H9.8c-3.2 0-5.8-2.6-5.8-5.8v-33h77.3v9.7c0 1.1.9 1.9 1.9 1.9s1.9-.9 1.9-1.9V9.7c0-5.3-4.3-9.7-9.7-9.7H9.7C4.4 0 0 4.4 0 9.7v42.7c0 5.4 4.3 9.7 9.7 9.7h34.8c1.1 0 1.9-.9 1.9-1.9.1-1.2-.8-2-1.8-2zM4 9.6c0-3.2 2.6-5.8 5.8-5.8h65.7c3.2 0 5.8 2.6 5.8 5.8v5.8H4V9.6zm40.6 17.5H13.7c-1.1 0-1.9.9-1.9 1.9 0 1.1.9 1.9 1.9 1.9h30.9c1.1 0 1.9-.9 1.9-1.9 0-1-.9-1.9-1.9-1.9zM25.2 42.6c1.1 0 1.9-.9 1.9-1.9 0-1.1-.9-1.9-1.9-1.9H13.6c-1.1 0-1.9.9-1.9 1.9 0 1.1.9 1.9 1.9 1.9h11.6zm19.4-3.8H33c-1.1 0-1.9.9-1.9 1.9 0 1.1.9 1.9 1.9 1.9h11.6c1.1 0 1.9-.9 1.9-1.9 0-1.1-.9-1.9-1.9-1.9zm51.2 34.1L83.5 60.5c2.2-2.8 3.6-6.4 3.6-10.3 0-9.2-7.5-16.7-16.6-16.7-9.2 0-16.7 7.5-16.7 16.7s7.5 16.7 16.7 16.7c3.9 0 7.4-1.4 10.3-3.7l12.3 12.4c.4.4.9.6 1.4.6s1-.2 1.4-.6c.7-.7.7-2-.1-2.7zM70.5 63c-7 0-12.8-5.8-12.8-12.8 0-7.1 5.7-12.8 12.8-12.8s12.8 5.8 12.8 12.8c0 7.1-5.8 12.8-12.8 12.8z" />
                                        </svg>
                                    </div>

                                    <h2 className="text--40 text--light text--color">Gift Card / Voucher Lookup</h2>

                                    <LookupForm
                                        onCardNumberChange={this.handleCardNumberChange}
                                        onSubmit={this.handleSubmit}
                                        cardNumber={this.state.cardNumber} />

                                    {!this.state.isLoading && !this.state.response &&
                                        <p className="margin--30--top">Spaces will be ignored.</p>
                                    }

                                    {(this.state.isLoading || this.state.response) &&
                                        <div className="widget--giftcard__results text--center">
                                            <LoadingSpinner isVisible={this.state.isLoading} />

                                            {this.state.response && this.state.response.success &&
                                                <GiftcardInfo
                                                    {...this.state.response.json.giftcard}
                                                    error={this.state.response.json.error}
                                                    errorDetail={this.state.response.json.errorDetail}
                                                    cardNumber={this.state.cardNumber}
                                                />
                                            }

                                            {this.state.response && !this.state.response.success &&
                                                <div className="container max-width--500 text--18">
                                                    <h3 className="text--orange text--light text--26 margin--20--bot">
                                                        <div className="alert alert--outline alert--error margin--10--bot">
                                                            <span> <a style={{ color: 'red' }} href="https://forms.monday.com/forms/bcfa00332929c63cd7bcd1184312f8ba?r=use1" target="_blank">Please ensure, Loyalty card number is not used for search.  Please enter a valid gift card or voucher number. Please click <strong style={{ fontWeight: 500 }}><u>here</u></strong> to raise IT request.</a></span>
                                                        </div>
                                                    </h3>
                                                </div>
                                            }
                                        </div>
                                    }

                                </div>

                            </div>
                        </div>

                    </main>
                    <footer className="footer--help">

                        {/*<a href="#" className="btn btn--white btn--small btn--help">Help</a>*/}

                        {/* Modal content goes here */}
                    </footer>

                </div>
                : <NotFound forbidden={true} />
        )
    }
}

export default withAuth(GiftcardLookup);
